import Blue from "~/core";

new Blue({
  name: "Active Options Table",
  selector: "#todaysActiveOptions",
  setup(active) {
    const equity = active.querySelector("table#equityData");
    const index = active.querySelector("table#indexData");
    const etf = active.querySelector("table#etfData");
    $(equity).tablesorter()
    $(index).tablesorter()
    $(etf).tablesorter()
  }
})
 